import React from "react";
import { Eyebrow } from "./Section";

export default function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative overflow-hidden border-b border-white/10">
      <div className="absolute inset-0 grid-backdrop opacity-50" aria-hidden="true" />
      <div className="absolute inset-0 radial-fade" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8 pt-32 pb-14 lg:pt-36 lg:pb-16">
        <div className="max-w-3xl animate-fade-up">
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          <h1 className="mt-5 text-4xl sm:text-5xl font-bold leading-[1.06] text-foreground text-balance">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-5 text-lg text-muted-foreground leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </div>
      </div>
    </section>
  );
}
